import React, { Component } from 'react';
import styled from 'styled-components';
import { fmtValue } from '../model/dashboardCalc';

const W = 720;
const H = 265;
const LEFT = 44;
const RIGHT = 15;
const TOP = 18;
const BOTTOM = 33;

// 다중 시리즈 꺾은선 차트 (실측 vs 예측, CBL vs 감축 운전)
// series: [{ data: number[], color: string }]
class MultiLineChart extends Component {
  isValid() {
    const { labels, series } = this.props;
    return (
      Array.isArray(labels) &&
      labels.length >= 2 &&
      !series.some((s) => !Array.isArray(s.data) || s.data.length !== labels.length)
    );
  }

  render() {
    const { labels, series, ariaLabel } = this.props;
    const all = this.isValid() ? series.flatMap((s) => s.data).filter(Number.isFinite) : [];

    if (!all.length) {
      return <Svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label={ariaLabel} />;
    }

    let min = Math.min(...all);
    let max = Math.max(...all);
    const span = Math.max(1, max - min);
    min = Math.max(0, min - span * 0.2);
    max += span * 0.2;

    const x = (i) => LEFT + ((W - LEFT - RIGHT) * i) / (labels.length - 1);
    const y = (v) => TOP + (H - TOP - BOTTOM) * (1 - (v - min) / (max - min));
    const labelStep = Math.max(1, Math.ceil(labels.length / 7));
    const dotStep = Math.max(1, Math.ceil(labels.length / 12));

    return (
      <Svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label={ariaLabel}>
        {[0, 1, 2, 3, 4].map((i) => {
          const yy = TOP + ((H - TOP - BOTTOM) * i) / 4;
          return (
            <g key={`grid-${i}`}>
              <line x1={LEFT} x2={W - RIGHT} y1={yy} y2={yy} stroke="#294057" strokeDasharray="3 5" />
              <text x={7} y={yy + 4}>
                {fmtValue(max - ((max - min) * i) / 4, '', 0)}
              </text>
            </g>
          );
        })}
        {labels.map((l, i) =>
          i % labelStep === 0 ? (
            <text key={`label-${i}`} x={x(i)} y={H - 8} textAnchor="middle">
              {l}
            </text>
          ) : null
        )}
        {series.map((s, si) => (
          <g key={`series-${si}`}>
            <polyline
              points={s.data.map((v, i) => `${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(' ')}
              fill="none"
              stroke={s.color}
              strokeWidth={3}
              strokeLinejoin="round"
              strokeLinecap="round"
            />
            {s.data.map((v, i) =>
              i % dotStep === 0 ? <circle key={`dot-${i}`} cx={x(i)} cy={y(v)} r={3} fill={s.color} /> : null
            )}
          </g>
        ))}
      </Svg>
    );
  }
}

const Svg = styled.svg`
  width: 100%;
  height: auto;
  display: block;

  text {
    fill: #90a9c3;
    font-size: 11px;
  }
`;

export default MultiLineChart;
